import * as actions from './actions';
import * as selectors from './selectors';
import reducer from './reducer';

export default {
  actions,
  selectors,
  reducer,
};
